// /components/GTMWithConsent.jsx
import Script from "next/script";
import { useEffect, useState } from "react";

/**
 * Combined GTM initialization + lightweight consent banner.
 * - GTM loads with Consent Mode defaults (denied).
 * - Consent Banner appears after 2s (if no prior choice).
 * - Consent updates persist in sessionStorage.
 */
export default function GTMWithConsent() {
  const GTM_ID = "GTM-KXZRG4LK"; // ← your GTM container ID
  const [open, setOpen] = useState(false);

  // Show banner only when no prior consent decision in session
  useEffect(() => {
    const accepted = sessionStorage.getItem("theTags1");
    const declined = sessionStorage.getItem("theTags2");
    if (!accepted && !declined) {
      const t = setTimeout(() => setOpen(true), 2000);
      return () => clearTimeout(t);
    }
  }, []);

  // Consent handlers
  const grantAll = () => {
    window.gtag?.("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
    sessionStorage.setItem("theTags1", "tagsAccepted");
    setOpen(false);
  };

  const rejectAll = () => {
    window.gtag?.("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    sessionStorage.setItem("theTags2", "tagsDeclined");
    setOpen(false);
  };

  return (
    <>
      {/* GTM + Consent Mode Defaults */}
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];
               w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
               var f=d.getElementsByTagName(s)[0],
               j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
               j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
               f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = gtag;
            gtag('consent','default',{
              ad_storage:'denied',
              analytics_storage:'denied',
              ad_user_data:'denied',
              ad_personalization:'denied'
            });
            gtag('set','url_passthrough',true);
            gtag('set','ads_data_redaction',true);
          `,
        }}
      />

      {/* noscript fallback (GTM still loads if JS is disabled) */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>

      {/* Consent Banner UI */}
      {open && (
        <div id="main-cookies-id" className="container-md main-cookies">
          <h4>Privacy Preferences</h4>
          <p>
            We use cookies and similar methods to recognize visitors, remember
            their preferences, measure ad campaign effectiveness and analyse
            traffic.
          </p>
          <div className="row">
            <div className="col">
              <button onClick={grantAll}>Accept All</button>
            </div>
            <div className="col">
              <button onClick={rejectAll}>Decline All</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
